import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { Textfit } from 'react-textfit'
import get from 'lodash.get'
import { connect } from 'react-redux'
import { Icon, Menu, Dropdown, Badge } from 'antd'
import { BsFillExclamationOctagonFill } from 'react-icons/bs'

import { logout } from '../../actions/application'
import { avatarURLParse } from '../../utils/urlParser'
import Avatar from '../Avatar'

import css from './index.scss'

const activeStyle = {
  fontWeight: 'bold',
  borderBottom: '2px solid red',
}

const iconStyles = {
  marginRight: 8,
  marginTop: 16,
  display: 'flex',
  width: 28,
  height: 28,
  color: '#ffffff',
  fontSize: 18,
}

class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      test: 1,
    }
  }

  render() {
    const { user } = this.props

    const profileMenu = (
      <Menu style={{ width: 250 }}>
        <Menu.Item key="5">
          <div className={css.header}>
            <Avatar
              src={avatarURLParse(get(this.props.user, 'avatar', ''))}
              alt="Perfil"
              noPicture="/assets/icons/profile.svg"
              size="mini"
            />
            <div className={css.column} style={{ marginLeft: 16 }}>
              <Textfit mode="single" max={18}>
                {`Olá, ${user && user.name && user.name.split(' ')[0]}`}
              </Textfit>

              <Textfit mode="single" max={13} className={css.subtitle}>
                {get(user, 'username', '')}
              </Textfit>
            </div>
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="0">
          <NavLink to="/settings" exact className={css.menuItem}>
            <Icon type="eye" theme="filled" style={{ marginRight: 16 }} />
            Ver perfil
          </NavLink>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="freightTables">
          <NavLink to="/freightTables" exact className={css.menuItem}>
            <Icon type="table" style={{ marginRight: 16 }} />
            Tabelas de Frete
          </NavLink>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="navbar_users">
          <NavLink to="/user-register" exact className={css.menuItem}>
            <Icon type="usergroup-add" style={{ marginRight: 16 }} />
            Usuários
          </NavLink>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="3">
          <NavLink to="/settings" exact className={css.menuItem}>
            <Icon type="setting" theme="filled" style={{ marginRight: 16 }} />
            Configurações
          </NavLink>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="2">
          <a
            onClick={() => this.props.logout()}
            tabIndex={0}
            role="button"
            className={css.menuItem}
          >
            <Icon type="logout" style={{ marginRight: 16 }} />
            Sair
          </a>
        </Menu.Item>
      </Menu>
    )

    const LoadDropdown = (
      <Menu style={{ width: 180 }}>
        <Menu.Item>
          <NavLink to="/tollVouchers" exact activeStyle={activeStyle}>
            <Icon type="tag" style={{ marginRight: 16 }} className={css.menuItem} />
            <span>Vale Pedágio</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    )

    return (
      <div className={css.navbar}>
        <div className={css.maxsize}>
          <NavLink to="/loads" exact>
            <img src="/assets/logo-az-ship-white.svg" alt="AZShip" className={css.logoStyle} />
          </NavLink>
          <div className={css.buttonsContainer}>
            <Dropdown overlay={LoadDropdown} trigger={['hover']} transitionName="">
              <NavLink to="/loads" className={css.buttonStyle} activeStyle={activeStyle}>
                <span>Cargas</span>
              </NavLink>
            </Dropdown>

            <NavLink to="/deliveryhistory" className={css.buttonStyle} activeStyle={activeStyle}>
              <span style={{ textWrap: 'nowrap' }}>Histórico de cargas</span>
            </NavLink>
            <NavLink to="/vehicles" className={css.buttonStyle} activeStyle={activeStyle}>
              <span>Veículos</span>
            </NavLink>
            <NavLink to="/drivers" className={css.buttonStyle} activeStyle={activeStyle}>
              <span>Motoristas</span>
            </NavLink>
            <NavLink to="/incidents" className={css.buttonStyle} activeStyle={activeStyle}>
              <span>Ocorrências</span>
            </NavLink>
            <NavLink to="/bids" className={css.buttonStyle} activeStyle={activeStyle}>
              <span>BID</span>
            </NavLink>
          </div>
          <div className={css.rightContent}>
            <div>
              <NavLink to="/invites">
                <Icon type="mail" style={iconStyles} theme="filled" />
              </NavLink>
            </div>
            {
              <NavLink
                to="/pendings?targetType=TRANSPORTER"
                style={{ marginTop: '-4px', marginRight: 16 }}
              >
                <Badge
                  count={this.props.pendingCount}
                  style={{
                    top: 7,
                    right: 9,
                    padding: 0,
                    minWidth: 18,
                    height: 17,
                  }}
                >
                  <BsFillExclamationOctagonFill className={css.blockIcon} />
                </Badge>
              </NavLink>
            }
            <div>
              <NavLink to="/notifications">
                <Icon type="bell" style={iconStyles} theme="filled" />
              </NavLink>
            </div>
            <Dropdown overlay={profileMenu} trigger={['click']}>
              <a className="ant-dropdown-link">
                <Avatar
                  src={avatarURLParse(get(user, 'avatar', ''))}
                  alt="Perfil"
                  noPicture="/assets/icons/profile.svg"
                  size="nano"
                />
              </a>
            </Dropdown>
          </div>
        </div>
      </div>
    )
  }
}

const mapActionsToProps = (dispatch) => ({
  logout() {
    dispatch(logout())
  },
})

const mapStateToProps = (state) => ({
  user: state.user,
  pendingCount: get(state, 'pendings.list', []).filter((item) => !item.viewed).length,
})

export default withRouter(connect(mapStateToProps, mapActionsToProps)(Navbar))
